import { AlertDialogDescription } from "@radix-ui/react-alert-dialog";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import reloadPage, { isAndroid, quitAndroidApp } from "../utils/AndroidBridge";
import isInsideIframe from "../utils/isInsideIframe";
import OrganizationScreen from "./OrganizationScreen";
import PairingScreen from "./PairingScreen";
import { AlertDialog, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";
import { Button } from "./ui/button";
import { useLogs } from "../hooks/useLogs";
import TVFrame from "./TVFrame";

export default function DefaultSlideShowScreen() {
  const { storeIsPreviewMode, storeOrgId, storeDeviceId, isPreviewMode } = useAuth();
  const [isPreviewDialogOpen, setIsPreviewDialogOpen] = useState(false);
  const exitRef = useRef<HTMLButtonElement>(null)
  const cancelRef = useRef<HTMLButtonElement>(null)
  const yesRef = useRef<HTMLButtonElement>(null)
  const refs = [cancelRef, yesRef, exitRef]

  useLayoutEffect(() => {
    setTimeout(() => {
      if (isPreviewDialogOpen) {
        yesRef.current?.focus()
      }
    }, 100)
  }, [isPreviewDialogOpen])

  function toggleMenu() {
    setIsPreviewDialogOpen(false)
    if (isPreviewMode) {
      storeIsPreviewMode(false)
      storeDeviceId()
      storeOrgId()
    } else {
      storeIsPreviewMode(true)
    }
    reloadPage()
  }

  useEffect(() => {
    if (!isInsideIframe()) {
      return;
    }

    const abortController = new AbortController()

    document.addEventListener("keyup", (e) => {
      switch (e.code) {
        case "Escape":
          e.stopPropagation()
          setIsPreviewDialogOpen(o => !o)
          break
      }
    }, abortController)

    return () => {
      abortController.abort()
    }
  }, [])

  useEffect(() => {
    const abortController = new AbortController()
    window.addEventListener("keydown", (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault()
        const currentIndex = refs.findIndex(ref => ref.current === document.activeElement)
        const nextIndex = (currentIndex + 1) % refs.length
        refs[nextIndex].current?.focus()
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault()
        const currentIndex = refs.findIndex(ref => ref.current === document.activeElement)
        const prevIndex = (currentIndex - 1 + refs.length) % refs.length
        refs[prevIndex].current?.focus()
      }
    }, abortController)

    return () => {
      abortController.abort()
    }
  }, [])

  return (
    <>
      {isPreviewMode ? <PreviewScreen /> : <TVFrame>
        <PairingScreen />
      </TVFrame>}
      <AlertDialog open={isPreviewDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle className="text-3xl">
              Switch to {isPreviewMode ? 'pairing' : 'preview'} mode?
            </AlertDialogTitle>
            <AlertDialogDescription></AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex flex-row gap-4">
            {isInsideIframe() && <Button ref={exitRef} onClick={() => {
              if (isAndroid()) return quitAndroidApp()
              window.parent.postMessage("exit_app", "*")
            }} size="xl" variant="ghost" className="focus:bg-black focus:text-white focus-visible:ring-8 focus-visible:ring-green-400 focus:scale-110 hover:bg-destructive/90">Exit App</Button>}
            <div className="flex-1"></div>
            <Button size="xl" onClick={() => setIsPreviewDialogOpen(false)} className="focus:bg-black focus:text-white focus-visible:ring-8 focus-visible:ring-green-400 focus:scale-110" variant="ghost" ref={cancelRef}>Cancel</Button>
            <Button ref={yesRef} size="xl" onClick={toggleMenu} variant="ghost" className="focus-visible:ring-8 focus-visible:ring-green-600 focus:scale-110 focus:bg-black focus:text-white">Continue</Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}

function PreviewScreen() {
  const { log } = useLogs()
  const { storeOrgId, storeDeviceId, deviceId, storeIsPreviewMode, screenInfo } = useAuth()

  useEffect(() => {
    if (!deviceId) {
      storeIsPreviewMode(true)
      storeDeviceId(import.meta.env.VITE_DEFAULT_DEVICE_ID)
      storeOrgId(import.meta.env.VITE_DEFAULT_ORG_ID)
    }
  }, [])

  useEffect(() => {
    // @ts-expect-error
    log({ eventtype: "Journey", name: "PreviewScreen", payload: { id: screenInfo?.id } })
  }, [screenInfo])

  return <div className="relative">
    {
      //<div className="absolute top-8 left-1/4 right-1/4 bg-foreground/80 px-4 py-2 rounded-md text-center text-background">Press Escape key to open menu</div>
    }
    {
      !screenInfo ? null : <OrganizationScreen initialScreenInfo={screenInfo} key={screenInfo.id} />
    }
  </div>
}